<template>
    <div>
        <transition name="fade">
            <div v-if="showDialogue" class="eva-button__dialogue">
                <div class="eva-button__dialogue-title">
                    <h1 v-html="getEvaDialogueTitle"></h1>
                    <span class="eva-button__dialogue-cancel icon-cancel" @click="closeEvaDialogue"></span>
                </div>
                <p class="eva-button__dialogue-paragraph" v-html="$t('EvaDialogue.paragraph')"></p>
                <button @click="openEvaChatBot" class="eva-button__dialogue-button eva">
                    <p v-html="$t('EvaDialogue.button_eva')"></p>
                    <span class="icon-chevron-right"></span>
                </button>
                <button @click="openCustomerSupport" class="eva-button__dialogue-button support">
                    <p v-html="$t('EvaDialogue.button_support')"></p>
                    <span class="icon-chevron-right"></span>
                </button>
                <div class="eva-button__dialogue-pointer"></div>
            </div>
        </transition>
        <div class="eva-button" @click="openChatModal">
            <button>
                <img src="@/assets/images/chatbot/eva_simple.png" :alt="$t('ChatBotCombo.eva_img_alt_text')" />
                <span
                    class="eva-button__unread-conversations-count"
                    v-if="unreadConversationsCount > 0">{{ unreadConversationsCount }}</span>
            </button>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'ShowChatBotButton',
        data () {
            return {
                showDialogue: false,
            }
        },
        computed: {
            ...mapGetters({
                showChatModal: 'ChatBotCombo/getShowChatModal',
                unreadConversationsCount: 'Hubspot/unreadConversationCount',
                currentChatMode: 'ChatBotCombo/getCurrentChatMode',
                isLoggedIn: 'isLoggedIn',
                currentUser: 'User/getCurrentUser'
            }),
            getEvaDialogueTitle () {
                return this.$t('EvaDialogue.title', { userName: this.currentUser.firstName })
            }
        },
        methods: {
            async openChatModal () {
                await this.$store.dispatch('ChatBotCombo/setShowChatModal', true)
                if (this.currentChatMode === 'hubspot') {
                    this.$store.dispatch('Hubspot/UnreadConversationCountChanged', 0)
                }
            },
            closeEvaDialogue () {
                this.showDialogue = false
                localStorage.setItem('dialogueShown', 'true')
            },
            openCustomerSupport () {
                if (Cookiebot.consent.statistics === false) {
                    this.openChatModal()
                    return
                }
                this.$store.dispatch('ChatBotCombo/setCurrentChatMode', 'hubspot')
                this.openChatModal()
                this.closeEvaDialogue()
                localStorage.setItem('dialogueShown', 'true')
            },
            openEvaChatBot () {
                this.$store.dispatch('ChatBotCombo/setCurrentChatMode', 'eva')
                this.openChatModal()
                this.closeEvaDialogue()
                localStorage.setItem('dialogueShown', 'true')
            }
        },
        created () {
            setTimeout(function () {
                document.querySelector('.eva-button').classList.add('shake')
            }, 10000)
            if (this.isLoggedIn && !localStorage.getItem('dialogueShown')) {
                setTimeout(() => {
                    this.showDialogue = true
                }, 3000)
            }
        }
    }
</script>

<style lang="scss" scoped>

.eva-button {
    position: fixed;
    right: 20px;
    bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-content: flex-end;
    z-index: 9991;

    --eva-button-size: 70px;
    --shadow: 0 0 6px 0 #00000080;

    &__dialogue {
        display: flex;
        padding: 20px 16px;
        flex-direction: column;
        justify-content: center;
        align-self: stretch;
        right: 20px;
        bottom: 110px;
        z-index: 10000;
        min-height: 220px;
        width: 350px;
        background: $old_lace;
        gap: 10px;
        border-radius: 5px;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        position: fixed;
        box-sizing: border-box;
        margin: 0;

        h1 {
            font-size: 1.8rem;
        }

        p {
            font-size: 1.7rem;
        }
    }

    &__dialogue-button {
        width: 100%;
        opacity: 1;
        animation: 0.5s ease-out 0s 1 normal forwards running fadeIn;
        background-color: white;
        padding: 9px 12px;
        border: 1px solid rgb(198, 83, 0);
        border-radius: 6px;
        cursor: pointer;
        color: rgb(0, 0, 0);
        font-family: Nunito-Regular, sans-serif;
        font-size: 1.4rem;
        display: flex;
        align-items: center;
        text-align: left;
        transition: background-color 0.3s;
        line-height: 19.1px;

        p {
            font-size: 1.3rem;
        }

        &.eva {
            border: solid 1px $rust_orange;

            &:hover {
                background-color: $manhattan;
            }

            span {
                color: $rust_orange;
            }
        }

        &.support {
            border: solid 1px $chambray;

            &:hover {
                background-color: $pattens_blue;
            }

            span {
                color: $chambray;
            }
        }

        span {
            margin-left: auto;
            font-size: 2.4rem;
        }
    }

    &__dialogue-pointer {
        height: 20px;
        width: 20px;
        background: $old_lace;
        margin: 0 auto;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        margin-top: -15px;
        position: absolute;
        z-index: -200;

        right: calc(13% - 20px);
        bottom: -10px;
    }

    &__dialogue-title {
        display: flex;
        justify-content: space-between;

        h1 {
            font-size: 2.1rem;
        }
    }

    &__dialogue-paragraph {
        margin: 0 0 10px;
    }

    &__dialogue-cancel {
        display: flex;
        font-size: 2.4rem;
        margin: 0px 10px;
    }

    button {
        width: var(--eva-button-size);
        height: var(--eva-button-size);
        appearance: none;
        border: none;
        background: linear-gradient(135deg, #30486D 0%, #4E74AD 100%);
        box-shadow: var(--shadow);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
        border-radius: 50%;
        cursor: pointer;
    }

    &:hover {
        transform: scale(1.2);
        transition: all 0.3s ease;

        button {
            background: linear-gradient(135deg, #4E74AD 0%, #30486D 100%);
        }
    }

    img {
        max-width: 100%;
    }

    &__unread-conversations-count {
        position: absolute;
        top: 0;
        right: 0;
        box-shadow: var(--shadow);
        width: 20px;
        height: 20px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        font-size:  1.2rem;
        color: $white;
        background: $metallic_red;
        border-radius: 50%;
    }

    &.shake {
        animation: shake 1s ease;
    }
}

@keyframes shake {
    0% { transform: translateX(0) rotate(0deg); }
    25% { transform: translateX(-5px) rotate(-5deg); }
    50% { transform: translateX(5px) rotate(5deg); }
    75% { transform: translateX(-5px) rotate(-5deg); }
    100% { transform: translateX(0) rotate(0deg); }
}

.fade-enter-active {
    transition: opacity 0.5s ease;
}

.fade-leave-active {
    transition: none;
}

.fade-enter {
    opacity: 0;
}

.fade-leave-to {
    opacity: 0;
}
</style>
